export default __webpack_public_path__ + "static/media/secondary-layout-background.8dd34540.jpg";